import { faPhone } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment/moment';
import React, { useState } from 'react';
import GenericModal from '../../components/agv-generic-modal';
import Row from '../../components/agv-generic-table/row';
import InputText from '../../components/agv-forms-input';
import InputRadio from '../../components/agv-forms-radio';
import { STATUS_ENUM } from '../../components/agv-status/status-enum';

export default function PhoneNumberModal({
  isOpen,
  setIsOpen,
  phoneNumber,
  updatePhoneNumber,
  mainActionIsLoading,
}) {
  const [title, setTitle] = useState(phoneNumber?.title);
  const [phone_number, setPhoneNumber] = useState(phoneNumber?.phone_number);
  const [isArchived, setIsArchived] = useState(phoneNumber?.is_archived === 1);

  const formatDate = (dateString) => {
    if (!dateString) return 'Non renseigné';
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const handleMainAction = () => {
    updatePhoneNumber(
      phoneNumber.id,
      title.trim(),
      phone_number.trim(),
      isArchived
    );
  };

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={'Numéro de téléphone'}
      mainAction={handleMainAction}
      mainActionText={'Enregistrer'}
      mainActionIsLoading={mainActionIsLoading}
      mainActionDisabled={!title?.length || !phone_number?.length}
    >
      <Row
        title={phoneNumber?.title}
        subtitle={`Créé le ${formatDate(phoneNumber?.created_at)}${phoneNumber?.updated_at ? ` • Modifié le ${formatDate(phoneNumber?.updated_at)}` : ''}`}
        icon={faPhone}
        iconColor={'tw-text-primary'}
        status={
          phoneNumber?.is_archived ? STATUS_ENUM.NEGATIVE : STATUS_ENUM.POSITIVE
        }
        statusText={phoneNumber?.is_archived ? 'Archivé' : 'Actif'}
        style={
          'tw-px-0 tw-border-solid tw-border-0 tw-border-b tw-border-background tw-py-4'
        }
      />

      <div className="tw-flex tw-flex-col tw-pb-6">
        <InputText
          value={title}
          setValue={setTitle}
          fieldTitle={'Titre'}
          isRequired
          emptyError={`Le champ "Titre" ne peut être vide.`}
          style={'tw-mt-6'}
          placeholder={'Support technique, Urgences, etc.'}
        />
        <InputText
          value={phone_number}
          setValue={setPhoneNumber}
          fieldTitle={'Numéro de téléphone'}
          isRequired
          emptyError={`Le champ "Numéro de téléphone" ne peut être vide.`}
          style={'tw-mt-6'}
          placeholder={'01 23 45 67 89'}
          type="tel"
        />

        <InputRadio
          fieldTitle={'État'}
          value={isArchived}
          setValue={setIsArchived}
          style={'tw-mt-6'}
          items={[
            { value: false, name: 'Activé' },
            { value: true, name: 'Archivé' },
          ]}
        />
      </div>
    </GenericModal>
  );
}
